import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link } from '@/shared/ui';

import { MonthlyRecapArticleModal } from '@/features/markets/components/MonthlyRecapArticle/MonthlyRecapArticleModal';
import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';
import { useDisclosure } from '@/shared/hooks/useDisclosure';

export const FeedArticleModalLink = ({
  article,
  CTALabel
}: {
  article: MonthlyRecapsArticle;
  CTALabel?: string;
}) => {
  const { isOpen, open, close } = useDisclosure();
  const [groupName, fileName] = article.file.split('/');

  return (
    <>
      <Link
        color='gx.highlight'
        component='button'
        data-ph-capture-attribute-component-type='feed-article'
        data-ph-capture-attribute-file-name={fileName}
        data-ph-capture-attribute-group-name={groupName}
        sx={{
          textDecoration: 'none',
          verticalAlign: 'baseline',
          display: 'inline-flex',
          alignItems: 'center'
        }}
        onClick={open}
      >
        {CTALabel ?? 'See the article'}
        <ChevronRightIcon sx={{ fontSize: '1em' }} />
      </Link>
      {isOpen && (
        <MonthlyRecapArticleModal
          article={article}
          onClose={close}
        />
      )}
    </>
  );
};
